import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';

export default function FloatingContact() {
  const [isOpen, setIsOpen] = useState(false);

  const contactOptions = [
    {
      id: 'whatsapp',
      name: 'WhatsApp',
      icon: FaIcons.FaWhatsapp,
      color: 'bg-[#25D366]',
      href: 'https://wa.me/61425228778?text=Hello%20BPA%20Solutions%2C%20I%20just%20viewed%20your%20demo%20hub%20and%20would%20like%20to%20discuss%20a%20potential%20project.',
      label: 'Chat on WhatsApp'
    },
    {
      id: 'sms',
      name: 'SMS Message',
      icon: FiIcons.FiSmartphone,
      color: 'bg-blue-500',
      href: 'sms:+61425228778?body=Hello%20BPA%20Solutions%2C%20I%27m%20interested%20in%20learning%20more%20about%20your%20automation%20solutions.',
      label: 'Send an SMS'
    },
    {
      id: 'email',
      name: 'Email Support',
      icon: FiIcons.FiMail,
      color: 'bg-slate-800',
      href: 'mailto:support@bpasolutions.au?subject=Inquiry%20from%20Demo%20Hub&body=Hello%20BPA%20Solutions%20team%2C%0D%0A%0D%0AI%20was%20browsing%20your%20demo%20hub%20and%20would%20like%20to%20enquire%20about...',
      label: 'Email us'
    }
  ];

  return (
    <div className="fixed bottom-6 right-6 z-[90] flex flex-col items-end">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.95 }}
            className="mb-4 flex flex-col gap-3"
          >
            {contactOptions.map((option, idx) => (
              <motion.a
                key={option.id}
                href={option.href}
                target={option.id === 'email' ? '_self' : '_blank'}
                rel="noopener noreferrer"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: idx * 0.05 }}
                className="flex items-center gap-3 group"
              >
                <span className="bg-white px-3 py-1.5 rounded-lg shadow-sm border border-slate-200 text-sm font-semibold text-slate-700 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                  {option.label}
                </span>
                <div className={`${option.color} w-12 h-12 rounded-full flex items-center justify-center text-white shadow-lg hover:scale-110 transition-transform active:scale-95`}>
                  <SafeIcon icon={option.icon} className="w-5 h-5" />
                </div>
              </motion.a>
            ))}
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setIsOpen(!isOpen)}
        className={`${isOpen ? 'bg-slate-100 text-slate-900' : 'bg-slate-900 text-white'} w-14 h-14 rounded-full flex items-center justify-center shadow-2xl transition-colors relative group`}
      >
        {!isOpen && (
          <div className="absolute -top-12 right-0 bg-blue-600 text-white text-[10px] font-bold px-3 py-1 rounded-full whitespace-nowrap shadow-xl animate-bounce">
            QUESTIONS? CHAT NOW
          </div>
        )}
        <SafeIcon icon={isOpen ? FiIcons.FiX : FiIcons.FiMessageCircle} className="w-6 h-6" />
      </motion.button>
    </div>
  );
}